import { gql } from '@apollo/client';

export const CreateDncMutation = gql`
  mutation CreateDnc($input: CreateDncInput!) {
    createDnc(createDncData: $input) {
      message
    }
  }
`;
